import { useState } from 'react';
export const useToggleState = (initialValue = false) => {
    const [value, setValue] = useState(initialValue);
    return [value, () => setValue(true), () => setValue(false), setValue];
};
